import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { UiButton, UiDrawer } from "../../../../components";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./style.scss";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const ViewDoc = ({
    isVisible,
    onClose,
    documentData = null,
    documents,
    setDocuments,
    selectedDocument,
    setSelectedDocument,
    loading,
    setLoading,
    handleDocumentSelect,
    handleDownload
}) => {
    const [numPages, setNumPages] = useState(null);
    
    const activeIndex = documents?.findIndex(doc => doc?.id === selectedDocument?.id) ?? 0;

    const getFileType = (fileUrl = "") => {
        const extension = fileUrl.split(".").pop().toLowerCase();
        if (["pdf"].includes(extension)) return "pdf";
        if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) return "image";
        if (["doc", "docx"].includes(extension)) return "word";
        return "other";
    };

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    useEffect(() => {
        setNumPages(null);
    }, [selectedDocument]);

    return (
        <UiDrawer
            title="Document's"
            onClose={onClose}
            open={isVisible}
            placement="left"
            width="70%"
            footer={
                <div className="flexible-end">
                    <UiButton onClick={onClose}>Close</UiButton>
                    <UiButton 
                        type="primary" 
                        onClick={handleDownload}
                        disabled={!selectedDocument}
                    >
                        Download
                    </UiButton>
                </div>
            }
        >
            <div style={{ display: "flex", gap: "0px 10px" }}>
                <div className="document-Name-Details">
                    <h2 className="information-detail">Document's</h2>
                    <div>
                        {documents && documents.length > 0 ? (
                            documents.map((doc, index) => (
                                <div key={doc?.id || index} style={{ paddingTop: "10px" }}>
                                    <div 
                                        className={activeIndex === index ? "document-active" : "document-info"}
                                        onClick={() => handleDocumentSelect(doc)}
                                    >
                                        <p style={{ padding: "5px 0px", margin: "5px" }}>
                                            {doc?.name || `Document ${index + 1}`}
                                        </p>
                                        <RightOutlined />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                                No documents available
                            </div>
                        )}
                    </div>
                </div>
                
                {loading ? (
                    <div style={{ margin: "auto", flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Spin spinning={loading} size="large" />
                    </div>
                ) : (
                    <div className="document-view" key={selectedDocument?.url || 'empty'}>
                        {(() => {
                            const fileType = getFileType(selectedDocument?.url);

                            switch (fileType) {
                                case "pdf":
                                    return (
                                        <Document
                                            key={selectedDocument?.url}
                                            file={selectedDocument?.url}
                                            onLoadSuccess={onDocumentLoadSuccess}
                                            onLoadError={(error) => console.error("Error loading PDF:", error)}
                                            loading={<p>Loading PDF...</p>}
                                        >
                                            {Array.from({ length: numPages || 0 }, (_, index) => (
                                                <div key={`page_${index + 1}`} style={{ marginBottom: "20px" }}>
                                                    <Page
                                                        pageNumber={index + 1}
                                                        width={600}
                                                        renderTextLayer={false}
                                                        renderAnnotationLayer={false}
                                                    />
                                                </div>
                                            ))}
                                        </Document>
                                    );
                                case "image":
                                    return (
                                        <div style={{ textAlign: "center" }}>
                                            <img
                                                src={selectedDocument?.url}
                                                alt="document preview"
                                                style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }}
                                            />
                                        </div>
                                    );
                                case "word":
                                    return (
                                        <iframe
                                            src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocument?.url)}&embedded=true`}
                                            title="Document Viewer"
                                            style={{ width: "100%", height: "80vh", border: "none" }}
                                        />
                                    );
                                default:
                                    return (
                                        <div style={{ textAlign: "center", padding: 20 }}>
                                            <p style={{ color: "#999" }}>Unsupported file type</p>
                                            <p style={{ fontSize: "12px", color: "#999" }}>{selectedDocument?.name}</p>
                                        </div>
                                    );
                            }
                        })()}
                    </div>
                )}
            </div>
        </UiDrawer>
    );
};

export default ViewDoc;
